
export const hasTableGenerator = (state) => state.tableGenerator.length > 0

